import { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible';

export const SettingsSection = ({ id, title, summary, icon: Icon, children, defaultOpen = false, error = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  useEffect(() => { if (error) setOpen(true); }, [error]);
  return <Collapsible open={open} onOpenChange={setOpen} className="settings-section" data-testid={`settings-${id}`}>
    <CollapsibleTrigger className="settings-section-trigger" type="button" data-testid={`settings-${id}-toggle`}>
      {Icon && <span className="settings-section-icon"><Icon size={19} aria-hidden="true" /></span>}
      <span className="settings-section-label"><strong>{title}</strong><span data-testid={`settings-${id}-summary`}>{error ? 'Check your settings' : summary}</span></span>
      <ChevronDown className="settings-chevron" size={17} aria-hidden="true" />
    </CollapsibleTrigger>
    <CollapsibleContent className="settings-section-content" data-testid={`settings-${id}-content`}>{children}</CollapsibleContent>
  </Collapsible>;
};